var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.handlePageScroll,
          expression: "handlePageScroll"
        },
        {
          name: "resize",
          rawName: "v-resize.initial",
          value: _vm.handleResize,
          expression: "handleResize",
          modifiers: { initial: true }
        }
      ],
      staticClass: "landing-container",
      class: _vm.style()
    },
    [
      _c(
        "mq-layout",
        { attrs: { mq: "desktop" } },
        [
          !_vm.hasCategories ? _c("BaseLoader") : _vm._e(),
          _vm._v(" "),
          !_vm.layout_hasSidebar ? _c("navigation-anchor-menu") : _vm._e(),
          _vm._v(" "),
          _c("recent-orders"),
          _vm._v(" "),
          _c("adapted-component", {
            attrs: { "adapter-name": "CouponContainer", path: "landing" }
          }),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category) {
            return [
              _c("category-detail", {
                key: category.id,
                attrs: { category: category }
              })
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "mq-layout",
        { attrs: { mq: ["mobile", "tablet"] } },
        [
          _c("customer-info-mobile"),
          _vm._v(" "),
          _c("adapted-component", {
            attrs: { "adapter-name": "CouponContainer", path: "landing" }
          }),
          _vm._v(" "),
          _c("no-recent-orders"),
          _vm._v(" "),
          _c("recent-orders"),
          _vm._v(" "),
          _c("adapted-component", {
            attrs: { "adapter-name": "MenuCategories", path: "menu" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-dialog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f74f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f74f74","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = null
// module chunks = 